import { Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  stopPlaying,
  cancelPlaying,
  autoSaveDraft,
  clearDraftMessage,
  SAVE_DRAFT,
} from '../../redux/draft';
import dateUtil from '../../util/dateUtil';
import EntryForm from '../EntryForm';

const NowPlaying = ({ draft }) => {
  const dispatch = useDispatch();

  const timecardEndDate = useSelector((state) => state.timecard?.endDate);
  //return if there's no draft
  if (!draft.id) return <Typography>Loading...</Typography>;

  return (
    <EntryForm
      closeLabel="Cancel"
      defaultDirty={true}
      entry={draft}
      apiLabel={SAVE_DRAFT}
      onClearMessage={() => dispatch(clearDraftMessage())}
      onSave={(entry) => {
        dispatch(
          stopPlaying(
            {
              ...entry,
              status: 'STOPPED',
              endTime: entry.endTime || dateUtil.nowTimeString(), //default the end time to now if blank
              hours:
                entry.hours && entry.hours != 0
                  ? entry.hours
                  : dateUtil.calcHours(
                    entry.startDate,
                    entry.startTime,
                    entry.endDate,
                    entry.endTime || dateUtil.nowTimeString()
                  ),
            },
            true
          )
        );
      }}
      onAutoSave={(entry) => {
        dispatch(autoSaveDraft(entry));
      }}
      onCancel={(entry) => {
        dispatch(cancelPlaying(entry));
      }}
      nowPlaying="true"
      smallDates="true"
      saveLabel="Stop"
      onValidate={(entry) => {
        if (
          !entry.endDate ||
          !entry.startDate ||
          !entry.startTime ||
          entry.startDate.substr(0, 10) > timecardEndDate
        )
          return {
            endDate: !entry.endDate ? 'Required' : undefined,
            startDate: !entry.startDate
              ? 'Required'
              : entry.startDate.substr(0, 10) > timecardEndDate
                ? 'After period end'
                : undefined,
            startTime: !entry.startTime ? 'Required' : undefined,
          };
        else return undefined;
      }}
    />
  );
};

export default NowPlaying;
